export const systemsColors = [
    { name: "psft", displayName: "PeopleSoft", color: "primary" },
    { name: "xero", displayName: "Xero", color: "dark" },
    { name: "cmic", displayName: "CMIC", color: "success" },
    { name: "mrix", displayName: "MRIx", color: "danger" },
    { name: "jde", displayName: "JDE", color: "warning" },
    { name: "sage", displayName: "Sage", color: "info" },
    { name: "other", displayName: "Other", color: "secondary" },
];
